import { Box, Button, DialogActions } from "@mui/material";
import React, { MutableRefObject } from "react";
import { SubForms } from "./VariantUpsell/CreateUpsellDialog";
import { FieldValues, UseFormTrigger } from "react-hook-form";

export type FormStepProps = {
  stepIndex: number;
  subForms: MutableRefObject<SubForms>;
};

export function SwiperStepperActions<T extends FieldValues>({
  cancel,
  previous,
  next,
  isValid,
  pages,
  currentPage,
  onSubmit,
}: {
  next: () => void;
  previous: () => void;
  cancel: () => void;
  isValid: UseFormTrigger<T>;
  pages: number;
  currentPage: number;
  onSubmit: () => void;
}) {
  return (
    <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
      <Button onClick={cancel}>Cancel</Button>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          disabled={currentPage === 0}
          onClick={function () {
            previous();
          }}
          variant={"contained"}
        >
          Previous
        </Button>
        {currentPage === pages - 1 ? (
          <Button color={"success"} onClick={onSubmit} variant={"contained"}>
            Create upsell
          </Button>
        ) : (
          <Button
            color={"success"}
            onClick={async function () {
              if (await isValid()) {
                next();
              }
            }}
            variant={"contained"}
          >
            Next
          </Button>
        )}
      </Box>
    </DialogActions>
  );
}
